import { get, type RequestOptions } from '@/api/client';
import type { SidebarCounts, WorkspaceBootstrap } from './types';

export const workspaceApi = {
  getBootstrap: (locationId: number, options?: RequestOptions) =>
    get<WorkspaceBootstrap>('/api/workspace/bootstrap', { location: locationId }, options),

  getSidebarCounts: (locationId: number, options?: RequestOptions) =>
    get<SidebarCounts>('/api/workspace/sidebar-counts', { location: locationId }, options),
};
